<template>
  <div class="titan-checkbox"
       :class="{'titan-checkbox-active': checked}"
       @click="toggle()"
  >
    <font-awesome-icon icon="check" class="titan-checkbox-icon"/>
  </div>
</template>

<script>
    export default {
        name: 'TitanCheckbox',
        props: {
            checked: {
                type: Boolean,
                required: true,
            }
        },
        methods: {
            toggle() {
                this.$emit('toggle')
            },
        }
    }
</script>

<style lang="scss">
  .titan-checkbox {
    cursor: pointer;
    width: 18px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #EFF1F4;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;

    &.titan-checkbox-active {
      background: #009DFA;
      border-color: #009DFA;
    }

    .titan-checkbox-icon {
      font-size: 10px;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/core/TitanCheckbox.vue